/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveConnections from './receive-connections';

export default () => (dispatch) => {
    dispatch({
        type: actions.CONNECTIONS_REQUEST,
    });

    return cecSdk
        .connection()
        .listAll()
        .then((connections) => {
            dispatch({
                type: actions.CONNECTIONS_REQUEST_SUCCESS,
            });
            dispatch(receiveConnections(connections));
            return connections;
        })
        .catch((e) => {
            dispatch({ type: actions.CONNECTIONS_REQUEST_FAILURE, error: e.message });
            throw e;
        });
};
